// extracted by mini-css-extract-plugin
export var callCard = "_q0-0";
export var callMessageButton = "_q0-1";
export var helpIcon = "_q0-3";
export var helpIconContainer = "_q0-4";
export var verticalDivider = "_q0-2";